var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"mini","plain":"","type":"info"},on:{"click":function($event){return _vm.go('/order/list2')}}},[_vm._v("应收费用")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","plain":"","type":"info"},on:{"click":function($event){return _vm.go('/order/notpaylist')}}},[_vm._v("已收费用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18011740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Common/OrderListHeader.vue
// module id = null
// module chunks = 